import { createAction, props } from '@ngrx/store';
import { TopicV2 } from '../../models';

export const TopicActions = {
  loadTopics: createAction('[Topics] Load Topics'),
  loadTopicsSuccess: createAction('[Topics] Load Topics Success', props<{ topics: TopicV2[] }>()),
};
